import React, { useState, useEffect } from "react";
import ApproveModal from "./ApproveModal";
import RetriggerModal from "./RetriggerModal";
import { BASE_URL } from "../../../env";
import axios from "axios";
import { Button } from "react-bootstrap";
import RejectModal from "./RejectModal";
import ApproveCreditManagerModal from "../../users-management/components/ApproveCreditManagerModal";
import { TiTick } from "react-icons/ti";
import { FaArrowRotateLeft } from "react-icons/fa6";
import { RxCross2 } from "react-icons/rx";
import ApproveSanctionCommitteeModal from "../../users-management/components/ApproveSanctionCommitteeModal";
import ApproveAccountManagerModal from "../../users-management/components/ApproveAccountManagerModal";
import UploadBranchManagerDocument from "./UploadBranchManagerDocument";
import DisburseBranchManagerModal from "../../users-management/components/DisburseBranchManagerModal";
import GenerateDocumentBranchManagerModal from "./GenerateDocumentBranchManagerModal";
import DisburseMisModal from "../../users-management/components/DisburseMisModal";
import ApproveMisModal from "../../users-management/components/ApproveMisModal";
import { useNavigate } from "react-router-dom";
import ShowBookingProcessModal from "./ShowBookingProcessModal";
import UploadBranchManagerBookingDocumentsStatic from "./UploadBranchManagerBookingDocumentsStatic";
import SaveDlTermsModal from "./SaveDlTermsModal";
import DlSignatureModal from "./DlSignatureModal";
import DlProofPhotosModal from "./DlProofPhotosModal";
import {
  fetchGoldRate,
  formatCurrency,
  computeGplCharges,
  computeInsuranceAboveThreshold,
  calculateEmiAmountRaw,
} from "../../../utils/utils";
import { computeDlCharges } from "../../../utils/dlCalculations";

const ActionButtons = ({
  roleId,
  item,
  updateList,
  managerId,
  proposedLoanAmount,
  setProposedLoanAmount,
  rateOfInterest,
  tenureInMonths,
  emiDateByCRO,
  emiDateByBM,
  fundingAgencyData,
  loanType,
  loanStyle,
  bookingProcessDetails,
  aadharNo,
  handleDelMember,
}) => {
  // console.log("ActionButtons Props:", {
  //   loanType,
  //   loanStyle,
  //   roleId,
  //   fieldManagerStatus: item.fieldManagerStatus,
  //   creditOfficerStatus: item.creditOfficerStatus,
  //   misStatus: item.misStatus,
  //   branchManagerStatus: item.branchManagerStatus,
  //   creditManagerStatus: item.creditManagerStatus,
  //   sanctionCommitteeStatus: item.sanctionCommitteeStatus,
  //   accountManagerStatus: item.accountManagerStatus,
  // });

  const navigate = useNavigate();
  const isDeveloper = roleId === "developer";
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showApproveMisModal, setShowApproveMisModal] = useState(false);
  const [memberId, setMemberId] = useState("");
  const [message, setMessage] = useState("");
  const [comment, setComment] = useState("");
  const [retriggerToRole, setRetriggerToRole] = useState("");
  const [showRetriggerModal, setShowRetriggerModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showApproveCreditManagerModal, setShowApproveCreditManagerModal] = useState(false);
  const [showDisburseMisModal, setShowDisburseMisModal] = useState(false);
  const [showApproveSanctionCommitteeModal, setShowApproveSanctionCommitteeModal] = useState(false);
  const [showApproveAccountManagerModal, setShowApproveAccountManagerModal] = useState(false);
  const [transactionAccountNumber, setTransactionAccountNumber] = useState("");
  const [transactionRefNo, setTransactionRefNo] = useState("");
  const [transactionDate, setTransactionDate] = useState(new Date());
  const [transactionAmount, setTransactionAmount] = useState("");
  const [showUploadBranchManagerDocumentModal, setShowUploadBranchManagerDocumentModal] = useState(false);
  const isRejected = [
    item.branchManagerStatus,
    item.creditOfficerStatus,
    item.misStatus,
    item.creditManagerStatus,
    item.sanctionCommitteeStatus,
    item.accountManagerStatus,
  ].some(s => (s || "").toString().toLowerCase().trim() === "rejected");

  const [showDisburseBranchManagerModal, setShowDisburseBranchManagerModal] = useState(false);
  const [showGenerateDocumentBranchManagerModal, setShowGenerateDocumentBranchManagerModal] = useState(false);
  const [showBookingProcessModal, setShowBookingProcessModal] = useState(false);
  const [showUploadBranchManagerBookingDocumentsStaticModal, setShowUploadBranchManagerBookingDocumentsStaticModal] = useState(false);
  // Daily Loan BM disbursement flow modals
  const [showDlTermsModal, setShowDlTermsModal] = useState(false);
  const [showDlSignatureModal, setShowDlSignatureModal] = useState(false);
  const [showDlProofPhotosModal, setShowDlProofPhotosModal] = useState(false);
  const [status, setStatus] = useState("");
  const [isProcessingChargePaid, setIsProcessingChargePaid] = useState(false);
  const [isGstPaid, setIsGstPaid] = useState(false);
  const [isSecurityDepositPaid, setIsSecurityDepositPaid] = useState(false);
  const [isSecurityDeposit1Paid, setIsSecurityDeposit1Paid] = useState(false);
  const [isLoanInsured, setIsLoanInsured] = useState(true);
  const [isInsuranceAmountPaid, setIsInsuranceAmountPaid] = useState(false);
  const [amountToRelease, setAmountToRelease] = useState(null);
  const [emiDateByBranchManager, setEmiDateByBranchManager] = useState(emiDateByBM ?? emiDateByCRO);
  // The date the first instalment is actually collected. Suggested below from
  // the EMI day and the disbursement date, and changeable by the Branch Manager
  // when the customer agreed something different (bugfix.md Bug 24).
  const [installmentStartDate, setInstallmentStartDate] = useState(
    item.installmentStartDate ?? null
  );
  const [ornamentModelNoByBm, setOrnamentModelNoByBm] = useState(
    item.ornamentModelNoByBm ?? bookingProcessDetails?.ornamentModelNo ?? ""
  );
  const [ornamentNameByBm, setOrnamentNameByBm] = useState(
    item.ornamentNameByBm ?? bookingProcessDetails?.ornamentName ?? ""
  );
  const [ornamentWeightByBm, setOrnamentWeightByBm] = useState(
    item.ornamentWeightByBm ?? bookingProcessDetails?.ornamentWeight ?? 0
  );
  const [wastageByBm, setWastageByBm] = useState(
    item.wastageByBm ?? bookingProcessDetails?.wastage ?? 0
  );
  const [gstByBm, setGstByBm] = useState(
    item.gstByBm ?? bookingProcessDetails?.gst ?? 0
  );
  const [goldRateByBm, setGoldRateByBm] = useState(
    item.goldRateByBm ?? bookingProcessDetails?.goldRate ?? 0
  );
  const [sanctionedLoanAmount, setSanctionedLoanAmount] = useState(
    item.sanctionedLoanAmountBySanctionCommittee ?? 0
  );
  const [processingCharge, setProcessingCharge] = useState(0);
  const [gst, setGst] = useState(0);
  const [securityDeposit, setSecurityDeposit] = useState(0);
  const [securityDeposit1, setSecurityDeposit1] = useState(0);
  const [insuranceAmount, setInsuranceAmount] = useState(0);
  const [totalLoanAmountByBm, setTotalLoanAmountByBm] = useState(
    item.totalLoanAmountByBm ?? bookingProcessDetails?.grandTotal ?? 0
  );
  const [bookingProcessData, setBookingProcessData] = useState(null);
  const [needCashLoan, setNeedCashLoan] = useState(false);
  const [cashLoanAmount, setCashLoanAmount] = useState(0);
  const [goldLoanTotal, setGoldLoanTotal] = useState(0);
  const [cashLoanTotal, setCashLoanTotal] = useState(0);

  const ornamentWeightValueByBm = Math.round(goldRateByBm * ornamentWeightByBm);
  const wastageValueByBm = Math.round((ornamentWeightValueByBm * wastageByBm) / 100);
  const totalByBm = Math.round(ornamentWeightValueByBm + wastageValueByBm);
  const gstValueByBm = Math.round((totalByBm * gstByBm) / 100);
  const eligibleLoanAmountByBm = totalByBm + gstValueByBm;

  const [loanFormDetails, setLoanFormDetails] = useState(null);

  // Suggest the first instalment date from the EMI day and the disbursement
  // date. Confirmed rule: collection always starts the calendar month AFTER
  // disbursement, on the agreed EMI day - never the disbursement month itself,
  // whatever the gap would be. The Branch Manager can still change it if the
  // customer agreed otherwise (bugfix.md Bug 24).
  //
  // This used to jump two months ahead whenever one month left a gap under
  // MIN_DAYS_TO_FIRST_EMI, on the assumption that a CRO would not collect only
  // a few days after disbursement. Checked against 1,537 loans with real
  // payment history: that heuristic predicted the customer's actual first
  // payment only 57.0% of the time, against 88.5% for always suggesting next
  // month. It is dropped rather than kept as a second guess.
  //
  // JLG is skipped: those loans repay on the centre meeting day, so a
  // per-customer start date does not apply.
  useEffect(() => {
    if (loanType === "JLG Loan") return;
    // Never overwrite a date a human already chose.
    if (item?.installmentStartDate) return;

    const disbursementDate = item?.branchManagerStatusUpdatedAt || new Date();
    const emiDay = parseInt(emiDateByBranchManager, 10);
    if (isNaN(emiDay) || emiDay < 1 || emiDay > 31) return;

    const disbursement = new Date(disbursementDate);
    if (isNaN(disbursement.getTime())) return;

    const month = disbursement.getMonth() + 1;
    const lastDay = new Date(
      disbursement.getFullYear(),
      month + 1,
      0
    ).getDate();
    const candidate = new Date(
      disbursement.getFullYear(),
      month,
      Math.min(emiDay, lastDay)
    );

    const yyyy = candidate.getFullYear();
    const mm = String(candidate.getMonth() + 1).padStart(2, "0");
    const dd = String(candidate.getDate()).padStart(2, "0");
    setInstallmentStartDate(`${yyyy}-${mm}-${dd}`);
  }, [
    emiDateByBranchManager,
    item?.branchManagerStatusUpdatedAt,
    item?.installmentStartDate,
    loanType,
  ]);

  // Sync state with item when it changes
  useEffect(() => {
    if (item) {
      if (item.sanctionedLoanAmountBySanctionCommittee) {
        setSanctionedLoanAmount(item.sanctionedLoanAmountBySanctionCommittee);
      }
      if (item.emiDateByBranchManager || item.emiDateByCRO) {
        setEmiDateByBranchManager(item.emiDateByBranchManager ?? item.emiDateByCRO);
      }
      if (item.isLoanInsured !== undefined) {
        setIsLoanInsured(item.isLoanInsured);
      } else if (loanType === "Business Loan") {
        setIsLoanInsured(true);
      }
    }
  }, [item]);

  useEffect(() => {
    if (loanType === "GP Loan") {
      const baseLoan = eligibleLoanAmountByBm + (needCashLoan ? cashLoanAmount : 0);
      // Insurance and the fee GST both key off the total loan amount - gold
      // eligibility plus any cash loan - and above the threshold the GST is
      // charged on processing fee + insurance. One shared rule, in utils.js,
      // so the form cannot disagree with itself (bugfix.md Bug 25).
      const charges = computeGplCharges({
        eligibleAmount: eligibleLoanAmountByBm,
        cashLoanAmount: needCashLoan ? cashLoanAmount : 0,
        agency: fundingAgencyData,
        tenureInMonths,
      });

      const calculatedProcessingCharge = charges.processingFee;
      const calculatedGst = charges.gst;
      const calculatedInsurance = charges.insurance;
      const calculatedSecurityDeposit1 = charges.securityDeposit1;

      const n = parseInt(tenureInMonths) || 1;
      const emi = calculateEmiAmountRaw(baseLoan, rateOfInterest, n);

      const calculatedSecurityDeposit = (fundingAgencyData && fundingAgencyData.gplSecurityDepositEnabled === false) ? 0 : Math.round(emi || 0);

      setProcessingCharge(calculatedProcessingCharge || 0);
      setGst(calculatedGst || 0);
      setInsuranceAmount(calculatedInsurance || 0);
      setSecurityDeposit1(calculatedSecurityDeposit1 || 0);
      setSecurityDeposit(calculatedSecurityDeposit || 0);
      setTotalLoanAmountByBm(baseLoan || 0);
    }
  }, [eligibleLoanAmountByBm, needCashLoan, cashLoanAmount, loanType, rateOfInterest, tenureInMonths, fundingAgencyData]);

  // Business Loan: processing charge percentage from funding agency, GST 18% or as per agency
  useEffect(() => {
    if (loanType === "Business Loan") {
      const baseLoan = Number(sanctionedLoanAmount) || 0;
      const fundingAgency = fundingAgencyData;

      let calculatedProcessingCharge = 0;
      let calculatedGst = 0;
      let calculatedInsurance = 0;
      let calculatedSecurityDeposit = 0;

      if (fundingAgency) {
        // Processing Fee calculation
        if (fundingAgency.blProcessingFeeEnabled) {
          calculatedProcessingCharge = Math.round(baseLoan * (Number(fundingAgency.blProcessingFeePercentage) / 100));
        }
        // GST calculation on processing charge
        if (fundingAgency.blGstEnabled) {
          calculatedGst = Math.round(calculatedProcessingCharge * (Number(fundingAgency.blGstPercentage) / 100));
        }
        // Insurance calculation - shared with GPL and JLG (bugfix.md Bug 57):
        // above Rs.2,00,000 (strictly - exactly 2L stays at the standard rate),
        // scaled by tenure against a 24-month base, plus GST on the premium
        // above that threshold from this agency's own blGstPercentage. This
        // used to compute only the tenure-scaled rate with no GST step at all;
        // GPL already had the GST step, BL did not.
        calculatedInsurance = computeInsuranceAboveThreshold(
          baseLoan,
          tenureInMonths,
          fundingAgency,
          "bl"
        ).insurance;
        // Security Deposit calculation - 1 month EMI if enabled
        if (fundingAgency.blSecurityDepositEnabled) {
          const n = tenureInMonths || 1;
          calculatedSecurityDeposit = Math.round(calculateEmiAmountRaw(baseLoan, rateOfInterest, n));
        }
      } else {
        // Fallback to defaults
        calculatedProcessingCharge = Math.round(baseLoan * 0.025);
        calculatedGst = Math.round(calculatedProcessingCharge * 0.18);
        // Default insurance calculation based on tenure (1.142% per year)
        calculatedInsurance = Math.round(baseLoan * (1.142 * (tenureInMonths / 12)) / 100);

        // Default security deposit calculation
        const n = tenureInMonths || 1;
        calculatedSecurityDeposit = Math.round(calculateEmiAmountRaw(baseLoan, rateOfInterest, n));
      }

      setProcessingCharge(calculatedProcessingCharge);
      setGst(calculatedGst);
      setInsuranceAmount(calculatedInsurance);
      setSecurityDeposit(calculatedSecurityDeposit);
    }
  }, [loanType, sanctionedLoanAmount, fundingAgencyData, rateOfInterest, tenureInMonths]);

  // Daily Loan: the Accounts Manager's summary needs the same 4 figures BL
  // computes above, but DL's are flat percentages of the sanctioned amount
  // (dlProcessingFeePercentage / dlSecurityDepositPercentage /
  // dlInsurancePercentage), never tenure-scaled - reusing BL's formula here
  // would charge 100+ months of insurance on a 100-day loan (see
  // frontend/src/utils/dlCalculations.js's own comment on computeDlCharges).
  // isLoanInsured is not read here: DL has no "is this loan insured" toggle,
  // insurance is on whenever the funding agency has dlInsuranceEnabled.
  useEffect(() => {
    if (loanType === "Daily Loan") {
      const charges = computeDlCharges({
        sanctionedAmount: Number(sanctionedLoanAmount) || 0,
        agency: fundingAgencyData,
      });
      setProcessingCharge(charges.processingFee);
      setGst(charges.gst);
      setInsuranceAmount(charges.insurance);
      setSecurityDeposit(charges.securityDeposit);
      setAmountToRelease(charges.amountToRelease);
    }
  }, [loanType, sanctionedLoanAmount, fundingAgencyData]);


  const handleSubmit = async (id, msg, modalName) => {
    setMemberId(id);
    setMessage(msg);

    if (modalName === "submit") {
      setShowApproveModal(true);
    } else if (modalName === "retrigger") {
      setShowRetriggerModal(true);
    } else if (modalName === "reject") {
      setShowRejectModal(true);
    } else if (modalName === "submitCreditManager") {
      setShowApproveCreditManagerModal(true);
    } else if (modalName === "disburseMis") {
      setShowDisburseMisModal(true);
    } else if (modalName === "approveSanctionCommittee") {
      setShowApproveSanctionCommitteeModal(true);
    } else if (modalName === "submitAccountManager") {
      // Seed the 4 transaction fields instead of opening the modal blank.
      //
      // - transactionAccountNumber / transactionRefNo: if the Accounts
      //   Manager already saved these once (e.g. a retrigger sent the loan
      //   back to them, or the record already has values from an earlier
      //   pass), show what is already stored rather than making them
      //   retype it.
      // - transactionDate: same, reformatted to the plain YYYY-MM-DD an
      //   <input type="date"> needs - the stored value is a full ISO
      //   timestamp (Sequelize DATE), which that input cannot display.
      // - transactionAmount: if one is already stored, keep it (an AM's own
      //   past entry is not silently overwritten). Otherwise default to the
      //   Sanction Committee's own figure - previously this opened blank
      //   and let the AM type ANY number with no validation against what
      //   was actually sanctioned, which is what let a Rs.55,000 sanction
      //   get recorded as a Rs.50,000 transaction with nothing to catch it.
      //   The AM can still edit it - this is a default, not a lock.
      setTransactionAccountNumber(item.transactionAccountNumber || "");
      setTransactionRefNo(item.transactionRefNo || "");
      setTransactionDate(
        item.transactionDate
          ? String(item.transactionDate).slice(0, 10)
          : new Date().toISOString().slice(0, 10)
      );
      setTransactionAmount(item.transactionAmount || sanctionedLoanAmount || "");

      if (loanType === "GP Loan") {
        try {
          // Fetch data from the loan form details API
          const loanFormResponse = await axios.get(`${BASE_URL}/api/loan/formdetails/${id}`);
          const loanFormData = loanFormResponse.data?.memberDetails || {};
          setLoanFormDetails(loanFormData);

          // Fetch booking process data
          const filter = JSON.stringify({ memberId: id });
          const response = await axios.get(
            `${BASE_URL}/api/getModelData/booking_process_bm?filter=${encodeURIComponent(filter)}`
          );
          const data = response.data?.data?.[0] || {};
          setBookingProcessData(data);
          setOrnamentModelNoByBm(data.ornamentModelNo || "");
          setOrnamentNameByBm(data.ornamentName || "");
          setOrnamentWeightByBm(data.ornamentWeight || 0);
          setWastageByBm(data.wastage || 0);
          setGstByBm(data.gst || 0);
          setGoldRateByBm(data.goldRate || 0);

          // Check if we have processingCharge, gst, and insuranceAmount from loanFormData
          if (loanFormData.processingCharge && loanFormData.gst && loanFormData.insuranceAmount) {
            // Use values from API response
            setProcessingCharge(loanFormData.processingCharge);
            setGst(loanFormData.gst);
            setInsuranceAmount(loanFormData.insuranceAmount);

            // Also set security deposit if available in response
            if (loanFormData.securityDeposit) {
              setSecurityDeposit(loanFormData.securityDeposit);
            }
          } else {
            // Calculate values if not available in API response
            const fetchedEligibleLoanAmount = Math.round((data.goldRate || 0) * (data.ornamentWeight || 0)) +
              Math.round(((data.goldRate || 0) * (data.ornamentWeight || 0) * (data.wastage || 0)) / 100) +
              Math.round(((data.goldRate || 0) * (data.ornamentWeight || 0) * (data.gst || 0)) / 100);

            // Seeded with the shared GPL rule so the figures never flash a
            // different number from the one the form finally charges (Bug 25).
            const seededCharges = computeGplCharges({
              eligibleAmount: fetchedEligibleLoanAmount,
              cashLoanAmount: needCashLoan ? cashLoanAmount : 0,
              agency: fundingAgencyData,
              tenureInMonths,
            });
            const calculatedProcessingCharge = seededCharges.processingFee;
            const calculatedGst = seededCharges.gst;
            const calculatedInsurance = seededCharges.insurance;
            const calculatedSecurityDeposit1 = seededCharges.securityDeposit1;
            const n = tenureInMonths || 1;
            const calculatedSecurityDeposit = Math.round(calculateEmiAmountRaw(fetchedEligibleLoanAmount, rateOfInterest, n));

            setProcessingCharge(calculatedProcessingCharge);
            setGst(calculatedGst);
            setInsuranceAmount(calculatedInsurance);
            setSecurityDeposit1(calculatedSecurityDeposit1);
            setSecurityDeposit(calculatedSecurityDeposit);
          }

          // If securityDeposit1 is not set from calculations above, calculate it
          if (!loanFormData.processingCharge || !loanFormData.gst || !loanFormData.insuranceAmount) {
            const fetchedEligibleLoanAmount = Math.round((data.goldRate || 0) * (data.ornamentWeight || 0)) +
              Math.round(((data.goldRate || 0) * (data.ornamentWeight || 0) * (data.wastage || 0)) / 100) +
              Math.round(((data.goldRate || 0) * (data.ornamentWeight || 0) * (data.gst || 0)) / 100);
            const calculatedSecurityDeposit1 = Math.round(fetchedEligibleLoanAmount * 0.01);
            setSecurityDeposit1(calculatedSecurityDeposit1);
          }

          // Set total loan amount from API if available, otherwise calculate
          if (loanFormData.totalLoanAmountByBm) {
            setTotalLoanAmountByBm(parseFloat(loanFormData.totalLoanAmountByBm));
          }
        } catch (error) {
          console.error("Error fetching booking process data for disbursement:", error);
          alert("Failed to fetch data for disbursement. Please try again.");
        }
      }
      setShowApproveAccountManagerModal(true);
    } else if (modalName === "uploadBranchManagerDocument") {
      setShowUploadBranchManagerDocumentModal(true);
    } else if (modalName === "disburseBranchManager") {
      if (loanType === "GP Loan") {
        try {
          // Fetch data from the loan form details API
          const loanFormResponse = await axios.get(`${BASE_URL}/api/loan/formdetails/${id}`);
          const loanFormData = loanFormResponse.data?.memberDetails || {};
          setLoanFormDetails(loanFormData);

          // Set gold and cash loan totals from fetched data (with fallback to 0)
          setGoldLoanTotal(loanFormData.goldloantotal || 0);
          setCashLoanTotal(loanFormData.cashtloanotal || 0);

          // Fetch booking process data
          const filter = JSON.stringify({ memberId: id });
          const response = await axios.get(
            `${BASE_URL}/api/getModelData/booking_process_bm?filter=${encodeURIComponent(filter)}`
          );
          const data = response.data?.data?.[0] || {};
          setBookingProcessData(data);
          setOrnamentModelNoByBm(data.ornamentModelNo || "");
          setOrnamentNameByBm(data.ornamentName || "");
          setOrnamentWeightByBm(data.ornamentWeight || 0);
          setWastageByBm(data.wastage || 0);
          setGstByBm(data.gst || 0);
          setGoldRateByBm(data.goldRate || 0);

          // Check if we have processingCharge, gst, and insuranceAmount from loanFormData
          if (loanFormData.processingCharge && loanFormData.gst && loanFormData.insuranceAmount) {
            // Use values from API response
            setProcessingCharge(loanFormData.processingCharge);
            setGst(loanFormData.gst);
            setInsuranceAmount(loanFormData.insuranceAmount);

            // Also set security deposit if available in response
            if (loanFormData.securityDeposit) {
              setSecurityDeposit(loanFormData.securityDeposit);
            }
          } else {
            // Calculate values if not available in API response
            const fetchedEligibleLoanAmount = Math.round((data.goldRate || 0) * (data.ornamentWeight || 0)) +
              Math.round(((data.goldRate || 0) * (data.ornamentWeight || 0) * (data.wastage || 0)) / 100) +
              Math.round(((data.goldRate || 0) * (data.ornamentWeight || 0) * (data.gst || 0)) / 100);

            // Seeded with the shared GPL rule so the figures never flash a
            // different number from the one the form finally charges (Bug 25).
            const seededCharges = computeGplCharges({
              eligibleAmount: fetchedEligibleLoanAmount,
              cashLoanAmount: needCashLoan ? cashLoanAmount : 0,
              agency: fundingAgencyData,
              tenureInMonths,
            });
            const calculatedProcessingCharge = seededCharges.processingFee;
            const calculatedGst = seededCharges.gst;
            const calculatedInsurance = seededCharges.insurance;
            const calculatedSecurityDeposit1 = seededCharges.securityDeposit1;
            const n = tenureInMonths || 1;
            const calculatedSecurityDeposit = Math.round(calculateEmiAmountRaw(fetchedEligibleLoanAmount, rateOfInterest, n));

            setProcessingCharge(calculatedProcessingCharge);
            setGst(calculatedGst);
            setInsuranceAmount(calculatedInsurance);
            setSecurityDeposit1(calculatedSecurityDeposit1);
            setSecurityDeposit(calculatedSecurityDeposit);
          }

          // If securityDeposit1 is not set from calculations above, calculate it
          if (!loanFormData.processingCharge || !loanFormData.gst || !loanFormData.insuranceAmount) {
            const fetchedEligibleLoanAmount = Math.round((data.goldRate || 0) * (data.ornamentWeight || 0)) +
              Math.round(((data.goldRate || 0) * (data.ornamentWeight || 0) * (data.wastage || 0)) / 100) +
              Math.round(((data.goldRate || 0) * (data.ornamentWeight || 0) * (data.gst || 0)) / 100);
            const calculatedSecurityDeposit1 = Math.round(fetchedEligibleLoanAmount * 0.01);
            setSecurityDeposit1(calculatedSecurityDeposit1);
          }

          // Set total loan amount from API if available, otherwise calculate
          if (loanFormData.totalLoanAmountByBm) {
            setTotalLoanAmountByBm(parseFloat(loanFormData.totalLoanAmountByBm));
          }
        } catch (error) {
          console.error("Error fetching booking process data for disbursement:", error);
          alert("Failed to fetch data for disbursement. Please try again.");
        }
      }
      setShowDisburseBranchManagerModal(true);
    } else if (modalName === "generateDocumentBranchManager") {
      try {
        if (loanType === "GP Loan") {
          let data = {};
          if (loanStyle === "existing" && aadharNo) {
            const response = await axios.get(`${BASE_URL}/api/getexistinggplrecord/${aadharNo}`);
            data = response.data?.data?.[0] || {};
          } else {
            const filter = JSON.stringify({ memberId: id });
            const response = await axios.get(
              `${BASE_URL}/api/getModelData/booking_process_bm?filter=${encodeURIComponent(filter)}`
            );
            data = response.data?.data?.[0] || {};
          }
          setBookingProcessData(data);
          setOrnamentModelNoByBm(data.ornamentModelNo || "");
          setOrnamentNameByBm(data.ornamentName || "");
          setOrnamentWeightByBm(data.ornamentWeight || 0);
          setWastageByBm(data.wastage || 0);
          setGstByBm(data.gst || 0);
          setGoldRateByBm(data.goldRate || 0);
          setIsLoanInsured(true);

          const fetchedEligibleLoanAmount = Math.round((data.goldRate || 0) * (data.ornamentWeight || 0)) +
            Math.round(((data.goldRate || 0) * (data.ornamentWeight || 0) * (data.wastage || 0)) / 100) +
            Math.round(((data.goldRate || 0) * (data.ornamentWeight || 0) * (data.gst || 0)) / 100);
          // Seeded with the shared GPL rule so the figures never flash a
          // different number from the one the form finally charges (Bug 25).
          const seededCharges = computeGplCharges({
            eligibleAmount: fetchedEligibleLoanAmount,
            cashLoanAmount: needCashLoan ? cashLoanAmount : 0,
            agency: fundingAgencyData,
            tenureInMonths,
          });
          const calculatedProcessingCharge = seededCharges.processingFee;
          const calculatedGst = seededCharges.gst;
          const calculatedInsurance = seededCharges.insurance;
          const calculatedSecurityDeposit1 = seededCharges.securityDeposit1;
          const n = tenureInMonths || 1;
          const calculatedSecurityDeposit = Math.round(calculateEmiAmountRaw(fetchedEligibleLoanAmount, rateOfInterest, n));

          setProcessingCharge(calculatedProcessingCharge);
          setGst(calculatedGst);
          setInsuranceAmount(calculatedInsurance);
          setSecurityDeposit1(calculatedSecurityDeposit1);
          setSecurityDeposit(calculatedSecurityDeposit);
          // The total loan amount is the gold eligibility plus any cash loan.
          // The charges are deducted from it, not added to it (Bug 25).
          setTotalLoanAmountByBm(seededCharges.totalLoanAmount);
        } else if (loanType === "Business Loan") {
          // For Business Loan, sanctionedLoanAmount should already be set from item via the sync useEffect
          // and calculations are handled by the Business Loan useEffect
          if (item.sanctionedLoanAmountBySanctionCommittee) {
            setSanctionedLoanAmount(item.sanctionedLoanAmountBySanctionCommittee);
          }
        }
      } catch (error) {
        console.error("Error fetching data for document generation:", error);
        alert("Failed to fetch data for document generation. Please try again.");
      }
      setShowGenerateDocumentBranchManagerModal(true);
    } else if (modalName === "submitMis") {
      setStatus("submitted");
      setShowApproveMisModal(true);
    } else if (modalName === "showBookingBm") {
      setShowBookingProcessModal(true);
    } else if (modalName === "uploadAndSubmitBmBooking") {
      setShowUploadBranchManagerBookingDocumentsStaticModal(true);
    } else if (modalName === "orderPlacedMis") {
      setStatus("orderPlaced");
      setShowApproveMisModal(true);
    } else if (modalName === "recheckFinally") {
      setStatus("recheckFinally");
      setShowApproveMisModal(true);
    }
  };

  const currentISTDateTime = new Date().toISOString();

  const handleApproveConfirm = async () => {
    try {
      const payload = {};
      if (roleId === "Branch Manager" || (roleId === "developer" && ["pending", "retrigger"].includes(item.branchManagerStatus))) {
        payload.memberId = memberId;
        payload.branchManagerStatus = "submitted";
        payload.branchManagerStatusUpdatedAt = currentISTDateTime;
      }
      if ((roleId === "Credit Officer" || (roleId === "developer" && ["pending", "retrigger"].includes(item.creditOfficerStatus))) && loanType === "Business Loan") {
        payload.memberId = memberId;
        payload.creditOfficerStatus = "submitted";
        payload.creditOfficerStatusUpdatedAt = currentISTDateTime;
      }
      if (roleId === "MIS" || (roleId === "developer" && ["pending", "retrigger"].includes(item.misStatus))) {
        payload.memberId = memberId;
        payload.misStatus = "submitted";
        payload.misStatusUpdatedAt = currentISTDateTime;
      }
      if (roleId === "Credit Manager" || (roleId === "developer" && ["pending", "retrigger"].includes(item.creditManagerStatus))) {
        payload.memberId = memberId;
        payload.creditManagerStatus = "submitted";
        payload.creditManagerStatusUpdatedAt = currentISTDateTime;
      }
      await axios.put(`${BASE_URL}/api/manager/message`, payload);
      updateList();
    } catch (error) {
      console.error("Error updating status:", error);
      alert("Failed to submit. Please try again.");
    } finally {
      setShowApproveModal(false);
    }
  };

  const handleCloseApprove = () => {
    setShowApproveModal(false);
  };

  const handleRetriggerConfirm = async () => {
    try {
      const payload = {};
      const formattedMessage =
        "\n" +
        comment +
        "\n---By " +
        roleId +
        "\n-- " +
        currentISTDateTime +
        "\n******** ";
      payload.memberId = memberId;

      const blOrder = [
        "Customer Relationship Officer",
        "Branch Manager",
        "Credit Officer",
        "MIS",
        "Credit Manager",
        "Sanction Committee",
        "Accounts Manager",
      ];
      const gplOrder = [
        "Customer Relationship Officer",
        "Branch Manager",
        "MIS",
        "Credit Manager",
        "Accounts Manager",
      ];

      // Daily Loan skips MIS and the Credit Manager entirely, and its Branch
      // Manager disburses AFTER the Sanction Committee rather than before it.
      //
      // That ordering is the whole point of this array. The reset sweep below is
      // purely index-ordered, so putting Branch Manager at index 1 as BL and GPL
      // do would make a Sanction Committee retrigger wrongly reset
      // branchManagerStatus, and a Branch Manager retrigger would compute
      // currentIdx < retriggerIdx and reset nothing at all.
      const dlOrder = [
        "Customer Relationship Officer",
        "Credit Officer",
        "Sanction Committee",
        "Branch Manager",
        "Accounts Manager",
      ];

      // Three-way, with the Business Loan and GP Loan outcomes unchanged. This
      // was `loanType === "GP Loan" ? gplOrder : blOrder`, a binary fallback that
      // silently sent a Daily Loan down the 7-stage BL route.
      const order =
        loanType === "Daily Loan"
          ? dlOrder
          : loanType === "GP Loan"
          ? gplOrder
          : blOrder;
      const roleToUseInOrder = retriggerToRole === "Branch Manager (Desktop)" ? "Branch Manager" : retriggerToRole;
      const retriggerIdx = order.indexOf(roleToUseInOrder);

      // For developer, we find the highest role that is not pending or null
      let currentIdx;
      if (roleId === "developer") {
        currentIdx = order.length - 1; // Start from end
        while (currentIdx >= 0) {
          const roleKey = {
            "Accounts Manager": "accountManagerStatus",
            "Sanction Committee": "sanctionCommitteeStatus",
            "Credit Manager": "creditManagerStatus",
            "MIS": "misStatus",
            "Credit Officer": "creditOfficerStatus",
            "Branch Manager": "branchManagerStatus",
            "Customer Relationship Officer": "fieldManagerStatus"
          }[order[currentIdx]];

          if (item[roleKey] && item[roleKey] !== "pending") break;
          currentIdx--;
        }
      } else {
        currentIdx = order.indexOf(roleId);
        // Only for Business Loan Stage 2 (BM2/MIS2) workflows, shift currentIdx to prevent resetting Stage 1
        const isBlStage2 = loanType === "Business Loan" && item.sanctionCommitteeStatus === "approved";
        if (isBlStage2 && (roleId === "Branch Manager" || roleId === "MIS")) {
          currentIdx = order.length;
        }
      }

      // Update Target Role Status
      if (retriggerToRole === "Customer Relationship Officer") {
        payload.fieldManagerStatus =
          roleId === "Accounts Manager" ? "retriggerToEditBankDetails" : "retrigger";
        payload.fieldManagerMessage = formattedMessage;
        payload.fieldManagerStatusUpdatedAt = currentISTDateTime;
      } else if (retriggerToRole === "Branch Manager" || retriggerToRole === "Branch Manager (Desktop)") {
        payload.branchManagerStatus = "retrigger";
        payload.branchManagerMessage = formattedMessage;
        payload.branchManagerStatusUpdatedAt = currentISTDateTime;
      } else if (retriggerToRole === "Credit Officer") {
        payload.creditOfficerStatus = "retrigger";
        payload.creditOfficerMessage = formattedMessage;
        payload.creditOfficerStatusUpdatedAt = currentISTDateTime;
      } else if (retriggerToRole === "MIS") {
        if (loanType === "GP Loan" && roleId === "Accounts Manager") {
          payload.misStatus = "retrigger_stage2";
        } else {
          payload.misStatus = "retrigger";
        }
        payload.misMessage = formattedMessage;
        payload.misStatusUpdatedAt = currentISTDateTime;
      } else if (retriggerToRole === "Credit Manager") {
        payload.creditManagerStatus = "retrigger";
        payload.creditManagerMessage = formattedMessage;
        payload.creditManagerStatusUpdatedAt = currentISTDateTime;
      } else if (retriggerToRole === "Sanction Committee") {
        payload.sanctionCommitteeStatus = "retrigger";
        payload.sanctionCommitteeMessage = formattedMessage;
        payload.sanctionCommitteeStatusUpdatedAt = currentISTDateTime;
      }

      // Reset stages AFTER both the retriggerer and the target to 'pending'
      // Roles between the target and the retriggerer remain 'submitted' as per established logic
      order.forEach((role, idx) => {
        if (idx > currentIdx && idx > retriggerIdx) {
          if (role === "Accounts Manager" && roleToUseInOrder !== "Accounts Manager") payload.accountManagerStatus = "pending";
          if (role === "Sanction Committee" && roleToUseInOrder !== "Sanction Committee") payload.sanctionCommitteeStatus = "pending";
          if (role === "Credit Manager" && roleToUseInOrder !== "Credit Manager") payload.creditManagerStatus = "pending";
          if (role === "MIS" && roleToUseInOrder !== "MIS") payload.misStatus = "pending";
          if (role === "Credit Officer" && roleToUseInOrder !== "Credit Officer") payload.creditOfficerStatus = "pending";
          if (role === "Branch Manager" && roleToUseInOrder !== "Branch Manager") payload.branchManagerStatus = "pending";
        }
      });

      // Also ensure current role status is updated back to pending only if retriggering backwards or to self
      // This prevents BM2 retrigger from putting the loan back into the BM1 (Approval Pending) stage.
      const isBlStage2 = loanType === "Business Loan" && item.sanctionCommitteeStatus === "approved";
      if (roleId === "Accounts Manager" && currentIdx >= retriggerIdx) payload.accountManagerStatus = "pending";
      if (roleId === "Sanction Committee" && currentIdx >= retriggerIdx) payload.sanctionCommitteeStatus = "pending";
      if (roleId === "Credit Manager" && currentIdx >= retriggerIdx) payload.creditManagerStatus = "pending";
      if (roleId === "MIS" && currentIdx >= retriggerIdx && !(loanType === "Business Loan" && isBlStage2)) payload.misStatus = "pending";
      if (roleId === "Credit Officer" && currentIdx >= retriggerIdx) payload.creditOfficerStatus = "pending";
      if (roleId === "Branch Manager" && currentIdx >= retriggerIdx && !(loanType === "Business Loan" && isBlStage2)) payload.branchManagerStatus = "pending";

      await axios.put(`${BASE_URL}/api/manager/message`, payload);
      updateList();
    } catch (error) {
      console.error("Error retriggering:", error);
      alert("Failed to retrigger. Please try again.");
    } finally {
      setShowRetriggerModal(false);
    }
  };

  const handleCloseRetrigger = () => {
    setShowRetriggerModal(false);
  };

  const handleRejectConfirm = async () => {
    try {
      const payload = {};
      const formattedMessage =
        "\n" +
        comment +
        "\n---By " +
        roleId +
        "\n-- " +
        currentISTDateTime +
        "\n******** ";
      if (roleId === "Branch Manager") {
        payload.memberId = memberId;
        payload.branchManagerStatus = "rejected";
        payload.branchManagerMessage = formattedMessage;
        payload.branchManagerStatusUpdatedAt = currentISTDateTime;
      }
      if (roleId === "Credit Officer" && loanType === "Business Loan") {
        payload.memberId = memberId;
        payload.creditOfficerStatus = "rejected";
        payload.creditOfficerMessage = formattedMessage;
        payload.creditOfficerStatusUpdatedAt = currentISTDateTime;
      }
      if (roleId === "MIS") {
        payload.memberId = memberId;
        payload.misStatus = "rejected";
        payload.misMessage = formattedMessage;
        payload.misStatusUpdatedAt = currentISTDateTime;
      }
      if (roleId === "Credit Manager") {
        payload.memberId = memberId;
        payload.creditManagerStatus = "rejected";
        payload.creditManagerMessage = formattedMessage;
        payload.creditManagerStatusUpdatedAt = currentISTDateTime;
      }
      if (roleId === "Sanction Committee" && loanType === "Business Loan") {
        payload.memberId = memberId;
        payload.sanctionCommitteeStatus = "rejected";
        payload.sanctionCommitteeMessage = formattedMessage;
        payload.sanctionCommitteeStatusUpdatedAt = currentISTDateTime;
      }
      if (roleId === "developer") {
        payload.memberId = memberId;
        // Determine which status to reject based on current stage
        if (["pending", "retrigger"].includes(item.branchManagerStatus)) payload.branchManagerStatus = "rejected";
        else if (["pending", "retrigger"].includes(item.creditOfficerStatus)) payload.creditOfficerStatus = "rejected";
        else if (["pending", "retrigger"].includes(item.misStatus)) payload.misStatus = "rejected";
        else if (["pending", "retrigger"].includes(item.creditManagerStatus)) payload.creditManagerStatus = "rejected";
        else if (["pending", "retrigger"].includes(item.sanctionCommitteeStatus)) payload.sanctionCommitteeStatus = "rejected";
        else if (["pending", "retrigger"].includes(item.accountManagerStatus)) payload.accountManagerStatus = "rejected";

        payload.branchManagerMessage = formattedMessage;
        payload.branchManagerStatusUpdatedAt = currentISTDateTime;
      }

      await axios.put(`${BASE_URL}/api/manager/message`, payload);
      updateList();
    } catch (error) {
      console.error("Error rejecting:", error);
      alert("Failed to reject. Please try again.");
    } finally {
      setShowRejectModal(false);
    }
  };

  const handleCloseReject = () => {
    setShowRejectModal(false);
  };

  const handleApproveConfirmCreditManager = async () => {
    try {
      const payload = {};
      if (roleId === "Credit Manager" || (roleId === "developer" && ["pending", "retrigger"].includes(item.creditManagerStatus))) {
        payload.memberId = memberId;
        payload.creditManagerStatus = "submitted";
        payload.creditManagerStatusUpdatedAt = currentISTDateTime;
      }

      await axios.put(`${BASE_URL}/api/manager/message`, payload);
      updateList();
    } catch (error) {
      console.error("Error approving credit manager:", error);
      alert("Failed to approve credit manager. Please try again.");
    } finally {
      setShowApproveCreditManagerModal(false);
    }
  };

  const handleCloseApproveCreditManager = () => {
    setShowApproveCreditManagerModal(false);
  };

  const handleDisburseConfirmMis = async () => {
    try {
      const payload = {};
      const formattedMessage =
        "\n" +
        comment +
        "\n---By " +
        roleId +
        "\n-- " +
        currentISTDateTime +
        "\n******** ";
      if (roleId === "MIS" || (roleId === "developer" && item.misStatus === "submitted")) {
        payload.memberId = memberId;
        payload.misStatus = "disbursed";
        payload.misMessage = formattedMessage;
        payload.misStatusUpdatedAt = currentISTDateTime;
      }

      await axios.put(`${BASE_URL}/api/manager/message`, payload);
      updateList();
    } catch (error) {
      console.error("Error disbursing MIS:", error);
      alert("Failed to disburse MIS. Please try again.");
    } finally {
      setShowDisburseMisModal(false);
    }
  };

  const handleCloseDisburseMis = () => {
    setShowDisburseMisModal(false);
  };

  const handleApproveConfirmMis = async () => {
    try {
      const payload = {};
      const formattedMessage =
        "\n" +
        comment +
        "\n---By " +
        roleId +
        "\n-- " +
        currentISTDateTime +
        "\n******** ";
      if (roleId === "MIS" || (roleId === "developer" && ["pending", "retrigger", "submitted", "orderPlaced", "recheckFinally"].includes(item.misStatus))) {
        payload.memberId = memberId;
        payload.misStatus = status;
        payload.creditManagerStatus = status === "orderPlaced" ? "pending" : payload.creditManagerStatus;
        payload.misMessage = formattedMessage;
        payload.misStatusUpdatedAt = currentISTDateTime;
      }

      const response = await axios.put(`${BASE_URL}/api/manager/message`, payload);
      console.log("MIS Approve Response:", response.data);
      updateList();
    } catch (error) {
      console.error("Error approving MIS:", error);
      alert("Failed to approve MIS. Please try again.");
    } finally {
      setShowApproveMisModal(false);
    }
  };

  const handleCloseApproveMis = () => {
    setShowApproveMisModal(false);
  };

  const handleApproveConfirmSanctionCommittee = async () => {
    try {
      const payload = {};
      if ((roleId === "Sanction Committee" || (roleId === "developer" && ["pending", "retrigger"].includes(item.sanctionCommitteeStatus))) && (loanType === "Business Loan" || loanType === "Daily Loan")) {
        payload.memberId = memberId;
        payload.sanctionCommitteeStatus = "approved";
        payload.sanctionCommitteeStatusUpdatedAt = currentISTDateTime;
        payload.sanctionedLoanAmountBySanctionCommittee = sanctionedLoanAmount;
      }

      await axios.put(`${BASE_URL}/api/manager/message`, payload);
      updateList();
    } catch (error) {
      console.error("Error approving sanction committee:", error);
      alert("Failed to approve sanction committee. Please try again.");
    } finally {
      setShowApproveSanctionCommitteeModal(false);
    }
  };

  const handleCloseApproveSanctionCommittee = () => {
    setShowApproveSanctionCommitteeModal(false);
  };

  const handleApproveConfirmAccountManager = async () => {
    try {
      const payload = {};
      if (roleId === "Accounts Manager" || (roleId === "developer" && ["pending", "retrigger"].includes(item.accountManagerStatus))) {
        payload.memberId = memberId;
        payload.accountManagerStatus = "payment credited";
        payload.accountManagerStatusUpdatedAt = currentISTDateTime;
        payload.creditManagerStatus = "submitted";
        payload.transactionAccountNumber = transactionAccountNumber || 0;
        payload.transactionRefNo = transactionRefNo;
        payload.transactionAmount = transactionAmount || 0;
        payload.transactionDate = transactionDate;
      }

      await axios.put(`${BASE_URL}/api/manager/message`, payload);
      updateList();
    } catch (error) {
      console.error("Error approving account manager:", error);
      alert("Failed to approve account manager. Please try again.");
    } finally {
      setShowApproveAccountManagerModal(false);
    }
  };

  const handleCloseApproveAccountManager = () => {
    setShowApproveAccountManagerModal(false);
  };

  const handleApproveConfirmUploadBranchManagerDocument = async () => {
    try {
      const payload = {};
      if ((roleId === "Credit Manager" || roleId === "Branch Manager") && loanType === "Business Loan") {
        payload.memberId = memberId;
        if (roleId === "Credit Manager") {
          payload.creditManagerStatus = "submitted";
          payload.creditManagerStatusUpdatedAt = currentISTDateTime;
        }
      }
      if (roleId === "Branch Manager" && loanType === "GP Loan") {
        payload.memberId = memberId;
      }

      if (Object.keys(payload).length > 1) {
        await axios.put(`${BASE_URL}/api/manager/message`, payload);
      }
      updateList();
    } catch (error) {
      console.error("Error uploading branch manager document:", error);
      alert("Failed to upload branch manager document. Please try again.");
    } finally {
      setShowUploadBranchManagerDocumentModal(false);
    }
  };

  const handleCloseUploadBranchManagerDocument = () => {
    setShowUploadBranchManagerDocumentModal(false);
  };

  const handleDisburseConfirmBranchManager = async () => {
    try {
      const payload = {};
      if (roleId === "Branch Manager" || (roleId === "developer" && item.branchManagerStatus === "disbursed")) {
        payload.memberId = memberId;
        payload.emiDateByBranchManager = emiDateByBranchManager || null;
        // JLG repays on the centre meeting day, so it carries no per-customer
        // start date (bugfix.md Bug 24).
        payload.installmentStartDate =
          loanType === "JLG Loan" ? null : installmentStartDate || null;
        payload.branchManagerStatus = "disbursed";
        payload.loanId = "";
        payload.loanStatus = "opened";
        if (loanType === "Business Loan") {
          payload.amountToRelease = amountToRelease;
          payload.branchManagerStatusUpdatedAt = currentISTDateTime;
          payload.processingCharge = processingCharge;
          payload.isProcessingChargePaid = isProcessingChargePaid;
          payload.gst = gst;
          payload.isGstPaid = isGstPaid;
          payload.securityDeposit = securityDeposit;
          payload.isSecurityDepositPaid = isSecurityDepositPaid;
          payload.isSecurityDeposit1Paid = isSecurityDeposit1Paid;
          payload.isLoanInsured = isLoanInsured;
          payload.insuranceAmount = insuranceAmount;
          payload.isInsuranceAmountPaid = isInsuranceAmountPaid;
        }
        if (loanType === "GP Loan") {
          payload.totalLoanAmountByBm = totalLoanAmountByBm;
          payload.branchManagerStatusUpdatedAt = currentISTDateTime;
        }
      }

      await axios.put(`${BASE_URL}/api/manager/message`, payload);
      updateList();
    } catch (error) {
      console.error("Error disbursing branch manager:", error);
      alert("Failed to disburse branch manager. Please try again.");
    } finally {
      setShowDisburseBranchManagerModal(false);
    }
  };

  const handleCloseDisburseBranchManager = () => {
    setShowDisburseBranchManagerModal(false);
  };

  const handleGenerateDocumentConfirmBranchManager = async () => {
    try {
      const payload = {
        memberId: memberId,
        managerId: managerId,
        branchManagerStatus: "submitted",
        branchManagerStatusUpdatedAt: currentISTDateTime,
      };

      const isAllowedRole = ["Branch Manager", "Credit Manager", "superadmin", "developer"].includes(roleId);

      if (isAllowedRole) {
        payload.proposedLoanAmount = proposedLoanAmount;
        payload.sanctionedLoanAmountBySanctionCommittee = sanctionedLoanAmount;
        payload.processingCharge = processingCharge;
        payload.isProcessingChargePaid = isProcessingChargePaid;
        payload.gst = gst;
        payload.isGstPaid = isGstPaid;
        payload.securityDeposit = securityDeposit;
        payload.isSecurityDepositPaid = isSecurityDepositPaid;
        payload.isSecurityDeposit1Paid = isSecurityDeposit1Paid;
        payload.isLoanInsured = isLoanInsured;
        payload.insuranceAmount = insuranceAmount;
        payload.isInsuranceAmountPaid = isInsuranceAmountPaid;
        payload.emiDateByBranchManager = emiDateByBranchManager || null;
        // JLG repays on the centre meeting day, so it carries no per-customer
        // start date (bugfix.md Bug 24).
        payload.installmentStartDate =
          loanType === "JLG Loan" ? null : installmentStartDate || null;

        if (roleId === "Credit Manager" || roleId === "superadmin" || roleId === "developer") {
          payload.creditManagerStatus = "submitted";
          payload.creditManagerStatusUpdatedAt = currentISTDateTime;
        }

        if (loanType === "Business Loan") {
          payload.amountToRelease = amountToRelease;
        }

        if (loanType === "GP Loan") {
          payload.goldRateByBm = goldRateByBm;
          payload.ornamentModelNoByBm = ornamentModelNoByBm;
          payload.ornamentNameByBm = ornamentNameByBm;
          payload.ornamentWeightByBm = ornamentWeightByBm;
          payload.ornamentWeightValueByBm = ornamentWeightValueByBm;
          payload.wastageByBm = wastageByBm;
          payload.wastageValueByBm = wastageValueByBm;
          payload.totalByBm = totalByBm;
          payload.gstByBm = gstByBm;
          payload.gstValueByBm = gstValueByBm;
          const baseLoan = eligibleLoanAmountByBm + (needCashLoan ? cashLoanAmount : 0);
          payload.eligibleLoanAmountByBm = baseLoan;
          payload.totalLoanAmountByBm = baseLoan;
          payload.securityDeposit = securityDeposit;
          payload.insuranceAmount = insuranceAmount;
          payload.goldloantotal = eligibleLoanAmountByBm;
          payload.cashtloanotal = needCashLoan ? cashLoanAmount : 0;
          payload.sanctionedLoanAmountBySanctionCommittee = baseLoan;
        }
      }

      await axios.put(`${BASE_URL}/api/manager/message`, payload);

      if (loanType === "GP Loan") {
        const additionalPayload = {
          model: "booking_process_bm",
          whereConditions: { memberId: memberId },
          goldRate: payload.goldRateByBm || 0,
          ornamentName: payload.ornamentNameByBm || "",
          ornamentModelNo: payload.ornamentModelNoByBm || "",
          ornamentWeight: payload.ornamentWeightByBm || 0,
          ornamentWeightValue: payload.ornamentWeightValueByBm || 0,
          wastage: payload.wastageByBm || 0,
          wastageValue: payload.wastageValueByBm || 0,
          // Not written back: total is the BM's pre-GST subtotal and securityDeposit
          // total: payload.goldloantotal || 0,
          gst: payload.gstByBm || 0,
          gstValue: payload.gstValueByBm || 0,
          grandTotal: payload.goldloantotal || 0,
          // here is the booking amount, not the loan deposit (bugfix.md).
          // securityDeposit: securityDeposit || 0,
          creditornamentWeight: payload.ornamentWeightByBm || 0,
          creditornamentWeightValue: payload.ornamentWeightValueByBm || 0,
          creditwastage: payload.wastageByBm || 0,
          creditwastageValue: payload.wastageValueByBm || 0,
          credittotal: payload.goldloantotal || 0,
          creditgst: payload.gstByBm || 0,
          creditgstValue: payload.gstValueByBm || 0,
          creditgrandTotal: payload.totalLoanAmountByBm || 0,
          securityDeposit1: securityDeposit1 || 0,
        };
        await axios.post(`${BASE_URL}/api/addOrEditDetails`, additionalPayload);
      }

      const response = await axios.get(`${BASE_URL}/api/loan/formdetails/${memberId}`);
      const data = response.data?.data?.[0] || response.data || {};
      setLoanFormDetails(data);
      updateList();
      localStorage.setItem("memberDetails", JSON.stringify(data));
      window.open("/memberdetail/print", "_blank");
    } catch (error) {
      console.error("Error generating document:", error);
      const errorMessage = error.response?.data?.details || error.response?.data?.error || error.message;
      alert(`Failed to generate document. Error: ${errorMessage}`);
    } finally {
      setShowGenerateDocumentBranchManagerModal(false);
    }
  };

  const handleCloseGenerateDocumentBranchManager = () => {
    setShowGenerateDocumentBranchManagerModal(false);
    setBookingProcessData(null);
  };

  const handleSaveBookingProcess = async (formData, denominations, goldRate) => {
    try {
      const payload = {
        model: "booking_process_bm",
        whereConditions: { memberId: memberId },
        goldRate: goldRate,
        ornamentModelNo: formData.ornamentModelNo,
        ornamentName: formData.ornamentName,
        ornamentWeight: formData.ornamentWeight,
        ornamentWeightValue: formData.ornamentWeightValue,
        wastage: formData.wastage,
        wastageValue: formData.wastageValue,
        total: formData.total,
        gst: formData.gst,
        gstValue: formData.gstValue,
        grandTotal: formData.grandTotal,
        bookingAmount: formData.bookingAmount,
        creditornamentWeight: formData.ornamentWeight,
        creditornamentWeightValue: formData.ornamentWeightValue,
        creditwastage: formData.wastage,
        creditwastageValue: formData.wastageValue,
        credittotal: formData.total,
        creditgst: formData.gst,
        creditgstValue: formData.gstValue,
        creditgrandTotal: formData.grandTotal,
        denominations: Object.entries(denominations).map(([denomination, { count }]) => ({
          denomination: parseInt(denomination),
          count: count || 0,
          total: (count || 0) * parseInt(denomination),
        })),
      };
      await axios.post(`${BASE_URL}/api/addOrEditDetails`, payload);
      const response = await axios.get(`${BASE_URL}/api/loan/formdetails/${memberId}`);
      updateList();
      localStorage.setItem("memberDetails", JSON.stringify(response.data));
      window.open("/bookingReceipt/print", "_blank");
    } catch (error) {
      console.error("Error saving booking process:", error);
      alert("Failed to save booking process. Please try again.");
    } finally {
      setShowBookingProcessModal(false);
    }
  };

  const handleCloseBookingProcess = () => {
    setShowBookingProcessModal(false);
  };

  const handleSubmitUploadBookingProcess = async () => {
    try {
      updateList();
    } catch (error) {
      console.error("Error submitting booking process upload:", error);
      alert("Failed to submit booking process upload. Please try again.");
    } finally {
      setShowUploadBranchManagerBookingDocumentsStaticModal(false);
    }
  };

  const handleCloseUploadBookingProcess = () => {
    setShowUploadBranchManagerBookingDocumentsStaticModal(false);
  };

  const availableRetriggerRoles = () => {
    let roles = [];
    if (loanType === "Daily Loan") {
      // Only roles that exist in dlOrder may be offered. MIS and Credit Manager
      // are not in the DL route, and order.indexOf returns -1 for them - a
      // retriggerIdx of -1 makes the reset sweep wipe the entire chain.
      //
      // "Back exactly one stage" is enforced here, by what the dropdown offers,
      // because handleRetriggerConfirm cannot express it: it retriggers to
      // whichever role is chosen.
      if (roleId === "Credit Officer") {
        roles.push("Customer Relationship Officer");
      }
      if (roleId === "Sanction Committee") {
        roles.push("Credit Officer");
      }
      if (roleId === "Branch Manager") {
        roles.push("Sanction Committee");
      }
      if (roleId === "Accounts Manager") {
        roles.push("Branch Manager");
      }
    } else if (loanType === "Business Loan") {
      if (roleId === "Branch Manager") {
        roles.push("Sanction Committee");
      }
      if (roleId === "Credit Officer") {
        roles.push("Customer Relationship Officer", "Branch Manager");
      }
      if (roleId === "MIS") {
        roles.push("Customer Relationship Officer");
        if (["pending", "retrigger"].includes(item.misStatus)) {
          roles.push("Branch Manager", "Credit Officer");
        } else {
          roles.push("Branch Manager (Desktop)");
        }
      }
      if (roleId === "Credit Manager") {
        roles.push("Customer Relationship Officer", "Branch Manager", "Credit Officer", "MIS");
      }
      if (roleId === "Sanction Committee") {
        roles.push("Customer Relationship Officer", "Branch Manager", "Credit Officer", "MIS", "Credit Manager");
      }
      if (roleId === "Accounts Manager") {
        roles.push("Customer Relationship Officer", "Branch Manager (Desktop)");
      }
    } else {
      if (roleId === "Branch Manager") {
        roles.push("Customer Relationship Officer");
      }
      if (roleId === "MIS") {
        roles.push("Customer Relationship Officer", "Branch Manager");
      }
      if (roleId === "Credit Manager") {
        roles.push("Customer Relationship Officer", "Branch Manager", "MIS");
      }
      if (roleId === "Accounts Manager") {
        roles.push("Customer Relationship Officer", "Branch Manager");
      }
    }
    return roles;
  };

  return (
    <div style={{ display: "flex", gap: "10px" }}>
      {((loanType === "Business Loan" &&
        (roleId === "MIS" || isDeveloper) &&
        item.fieldManagerStatus === "submitted" &&
        item.branchManagerStatus === "submitted" &&
        item.creditOfficerStatus === "submitted" &&
        ["pending", "retrigger"].includes(item.misStatus)) ||
        ((roleId === "Credit Manager" || isDeveloper) &&
          loanType === "GP Loan" &&
          item.fieldManagerStatus === "submitted" &&
          (item.misStatus !== "pending" && item.misStatus !== null && item.misStatus !== "" && item.misStatus !== "retrigger") &&
          ["pending", "retrigger"].includes(item.creditManagerStatus))) && (
          <div className="mb-1">
            <Button
              variant="success"
              onClick={() => handleSubmit(item.id, "Are you sure you want to Submit?", "submit")}
            >
              <TiTick size={20} /> Submit
            </Button>
          </div>
        )}
      {(((roleId === "Credit Manager" || isDeveloper) &&
        loanType === "Business Loan" &&
        item.fieldManagerStatus === "submitted" &&
        item.branchManagerStatus === "submitted" &&
        item.creditOfficerStatus === "submitted" &&
        item.misStatus === "submitted" &&
        ["pending", "retrigger"].includes(item.creditManagerStatus)) ||
        ((roleId === "MIS" || isDeveloper) &&
          item.fieldManagerStatus === "submitted" &&
          item.branchManagerStatus === "submitted" &&
          item.creditOfficerStatus === "submitted" &&
          item.misStatus === "retrigger" &&
          item.sanctionCommitteeStatus === "approved") ||
        ((roleId === "Credit Manager" || isDeveloper) &&
          item.fieldManagerStatus === "submitted" &&
          item.creditOfficerStatus === "submitted" &&
          item.misStatus === "submitted" &&
          item.creditManagerStatus === "retrigger" &&
          item.sanctionCommitteeStatus === "approved")) && (
          <div className="mb-1">
            <Button
              variant="success"
              onClick={() => {
                if (roleId === "MIS" || isDeveloper) {
                  handleSubmit(item.id, "Are you sure you want to Submit?", "submitMis");
                } else if (roleId === "Credit Officer" || roleId === "Branch Manager" || isDeveloper) {
                  handleSubmit(item.id, "Are you sure you want to Submit?", "submit");
                } else {
                  handleSubmit(item.id, "Are you sure you want to Submit?", "submitCreditManager");
                }
              }}
            >
              <TiTick size={20} /> Submit
            </Button>
          </div>
        )}
      {((loanType === "Business Loan" &&
        (roleId === "Branch Manager" || isDeveloper) &&
        item.fieldManagerStatus === "submitted" &&
        item.branchManagerStatus === "submitted" &&
        item.creditOfficerStatus === "submitted" &&
        item.misStatus === "submitted" &&
        item.creditManagerStatus === "submitted" &&
        item.sanctionCommitteeStatus === "approved" &&
        item.accountManagerStatus === "pending") ||
        (loanType === "Business Loan" &&
          (roleId === "MIS" || isDeveloper) &&
          item.fieldManagerStatus === "submitted" &&
          item.branchManagerStatus === "submitted" &&
          item.creditOfficerStatus === "submitted" &&
          ["pending", "retrigger"].includes(item.misStatus)) ||
        (loanType === "Business Loan" &&
          (roleId === "MIS" || isDeveloper) &&
          item.fieldManagerStatus === "submitted" &&
          item.branchManagerStatus === "disbursed" &&
          item.creditOfficerStatus === "submitted" &&
          item.misStatus === "submitted" &&
          item.creditManagerStatus === "submitted" &&
          item.sanctionCommitteeStatus === "approved" &&
          item.accountManagerStatus === "pending") ||
        ((roleId === "Credit Manager" || isDeveloper) &&
          item.fieldManagerStatus === "submitted" &&
          (loanType === "GP Loan" || item.branchManagerStatus === "submitted") &&
          ((loanType === "Business Loan" && item.creditOfficerStatus === "submitted" && item.misStatus === "submitted") ||
            (loanType === "GP Loan" && (item.misStatus !== "pending" && item.misStatus !== null && item.misStatus !== "" && item.misStatus !== "retrigger"))) &&
          ["pending", "retrigger"].includes(item.creditManagerStatus)) ||
        ((roleId === "Sanction Committee" || isDeveloper) &&
          loanType === "Business Loan" &&
          item.fieldManagerStatus === "submitted" &&
          item.branchManagerStatus === "submitted" &&
          item.creditOfficerStatus === "submitted" &&
          item.misStatus === "submitted" &&
          item.creditManagerStatus === "submitted" &&
          ["pending", "retrigger"].includes(item.sanctionCommitteeStatus)) ||
        (loanType === "Business Loan" &&
          (roleId === "Accounts Manager" || isDeveloper) &&
          item.fieldManagerStatus === "submitted" &&
          item.branchManagerStatus === "disbursed" &&
          item.creditOfficerStatus === "submitted" &&
          item.misStatus === "disbursed" &&
          item.creditManagerStatus === "submitted" &&
          item.sanctionCommitteeStatus === "approved" &&
          ["pending", "retrigger"].includes(item.accountManagerStatus)) ||
        (loanType === "GP Loan" &&
          (roleId === "MIS" || isDeveloper) &&
          item.fieldManagerStatus === "submitted" &&
          item.branchManagerStatus === "submitted" &&
          ["pending", "retrigger", "submitted", "orderPlaced", "recheckFinally"].includes(item.misStatus)) ||
        (loanType === "GP Loan" &&
          (roleId === "Credit Manager" || isDeveloper) &&
          item.fieldManagerStatus === "submitted" &&
          ["orderPlaced", "submitted", "recheckFinally"].includes(item.misStatus) &&
          ["pending", "retrigger"].includes(item.creditManagerStatus)) ||
        (loanType === "Business Loan" &&
          (roleId === "Sanction Committee" || isDeveloper) &&
          item.fieldManagerStatus === "submitted" &&
          item.branchManagerStatus === "submitted" &&
          item.creditOfficerStatus === "submitted" &&
          item.misStatus === "submitted" &&
          item.creditManagerStatus === "submitted" &&
          ["pending", "retrigger"].includes(item.sanctionCommitteeStatus)) ||
        (loanType === "GP Loan" &&
          (roleId === "Accounts Manager" || isDeveloper) &&
          item.fieldManagerStatus === "submitted" &&
          item.branchManagerStatus === "disbursed" &&
          item.misStatus === "recheckFinally" &&
          ["pending", "retrigger"].includes(item.accountManagerStatus)) ||
        // Daily Loan retrigger: each role can send the loan one step back.
        // CRO is excluded - it is the first stage and has nobody to retrigger to.
        (loanType === "Daily Loan" &&
          roleId === "Credit Officer" &&
          item.fieldManagerStatus === "submitted" &&
          ["pending", "retrigger"].includes(item.creditOfficerStatus)) ||
        (loanType === "Daily Loan" &&
          (roleId === "Sanction Committee" || isDeveloper) &&
          item.fieldManagerStatus === "submitted" &&
          item.creditOfficerStatus === "submitted" &&
          ["pending", "retrigger"].includes(item.sanctionCommitteeStatus)) ||
        // Branch Manager's own DL retrigger is mobile-only on web, matching
        // every other DL Branch Manager action (Save Terms through Disburse) -
        // excluded here so only `isDeveloper` can still reach it for testing.
        (loanType === "Daily Loan" &&
          isDeveloper &&
          item.fieldManagerStatus === "submitted" &&
          item.sanctionCommitteeStatus === "approved" &&
          ["pending", "retrigger"].includes(item.branchManagerStatus)) ||
        (loanType === "Daily Loan" &&
          (roleId === "Accounts Manager" || isDeveloper) &&
          item.fieldManagerStatus === "submitted" &&
          item.branchManagerStatus === "disbursed" &&
          ["pending", "retrigger"].includes(item.accountManagerStatus))) && (
          <div className="mb-2">
            <Button
              variant="warning"
              onClick={() => handleSubmit(item.id, "Are you sure you want to Retrigger?", "retrigger")}
            >
              <FaArrowRotateLeft size={17} />
            </Button>
          </div>
        )}
      {((loanType === "Business Loan" &&
        roleId === "Branch Manager" &&
        item.fieldManagerStatus === "submitted" &&
        ["submitted", "retrigger"].includes(item.branchManagerStatus) &&
        item.creditOfficerStatus === "submitted" &&
        item.misStatus === "submitted" &&
        item.creditManagerStatus === "submitted" &&
        item.sanctionCommitteeStatus === "approved" &&
        item.accountManagerStatus === "pending") ||
        (loanType === "GP Loan" &&
          roleId === "Branch Manager" &&
          item.fieldManagerStatus === "submitted" &&
          (item.misStatus !== "pending" && item.misStatus !== null && item.misStatus !== "" && item.misStatus !== "retrigger") &&
          item.creditManagerStatus === "submitted" &&
          item.accountManagerStatus === "pending") ||
        (loanType === "Business Loan" &&
          roleId === "MIS" &&
          item.fieldManagerStatus === "submitted" &&
          item.branchManagerStatus === "submitted" &&
          item.creditOfficerStatus === "submitted" &&
          ["pending", "retrigger"].includes(item.misStatus)) ||
        (roleId === "Credit Manager" &&
          item.fieldManagerStatus === "submitted" &&
          (loanType === "GP Loan" || item.branchManagerStatus === "submitted") &&
          ((loanType === "Business Loan" && item.creditOfficerStatus === "submitted" && item.misStatus === "submitted") ||
            (loanType === "GP Loan" && (item.misStatus !== "pending" && item.misStatus !== null && item.misStatus !== "" && item.misStatus !== "retrigger"))) &&
          ["pending", "retrigger"].includes(item.creditManagerStatus)) ||
        (roleId === "Sanction Committee" &&
          loanType === "Business Loan" &&
          item.fieldManagerStatus === "submitted" &&
          item.branchManagerStatus === "submitted" &&
          item.creditOfficerStatus === "submitted" &&
          item.misStatus === "submitted" &&
          item.creditManagerStatus === "submitted" &&
          ["pending", "retrigger"].includes(item.sanctionCommitteeStatus)) ||
        (loanType === "GP Loan" &&
          roleId === "MIS" &&
          item.fieldManagerStatus === "submitted" &&
          item.branchManagerStatus === "submitted" &&
          ["pending", "retrigger", "submitted"].includes(item.misStatus)) ||
        // Daily Loan reject: same four roles that can retrigger can also reject.
        (loanType === "Daily Loan" &&
          roleId === "Credit Officer" &&
          item.fieldManagerStatus === "submitted" &&
          ["pending", "retrigger"].includes(item.creditOfficerStatus)) ||
        (loanType === "Daily Loan" &&
          (roleId === "Sanction Committee" || isDeveloper) &&
          item.fieldManagerStatus === "submitted" &&
          item.creditOfficerStatus === "submitted" &&
          ["pending", "retrigger"].includes(item.sanctionCommitteeStatus)) ||
        (loanType === "Daily Loan" &&
          (roleId === "Branch Manager" || isDeveloper) &&
          item.fieldManagerStatus === "submitted" &&
          item.sanctionCommitteeStatus === "approved" &&
          ["terms_saved", "retrigger"].includes(item.branchManagerStatus)) ||
        (loanType === "Daily Loan" &&
          (roleId === "Accounts Manager" || isDeveloper) &&
          item.fieldManagerStatus === "submitted" &&
          item.branchManagerStatus === "disbursed" &&
          ["pending", "retrigger"].includes(item.accountManagerStatus)) ||
        isDeveloper) && (
          <div className="mb-2">
            <Button
              variant="danger"
              onClick={() => handleSubmit(item.id, "Are you sure you want to Reject?", "reject")}
            >
              <RxCross2 size={20} /> {isDeveloper && "Reject"}
            </Button>
          </div>
        )}
      {((roleId === "Credit Manager" &&
        item.fieldManagerStatus === "submitted" &&
        loanType === "GP Loan" &&
        (item.misStatus !== "pending" && item.misStatus !== null && item.misStatus !== "" && item.misStatus !== "retrigger") &&
        ["pending", "retrigger"].includes(item.creditManagerStatus)) ||
        (roleId === "Branch Manager" &&
          loanType === "GP Loan" &&
          item.fieldManagerStatus === "submitted" &&
          ["submitted"].includes(item.branchManagerStatus) &&
          item.creditManagerStatus !== "submitted") ||
        (roleId === "Branch Manager" &&
          loanType === "Business Loan" &&
          item.fieldManagerStatus === "submitted" &&
          item.branchManagerStatus === "submitted" &&
          item.creditOfficerStatus === "submitted" &&
          item.misStatus === "submitted" &&
          item.creditManagerStatus === "submitted" &&
          item.sanctionCommitteeStatus === "approved" &&
          item.accountManagerStatus === "pending") ||
        (roleId === "Branch Manager" &&
          loanType === "Business Loan" &&
          item.fieldManagerStatus === "submitted" &&
          ["retrigger"].includes(item.branchManagerStatus) &&
          item.creditOfficerStatus === "submitted" &&
          item.misStatus === "submitted" &&
          item.creditManagerStatus === "submitted" &&
          item.sanctionCommitteeStatus === "approved") ||
        isDeveloper) && (
          <div className="mb-1">
            <Button
              onClick={() => handleSubmit(item.id, "Are you sure you want to Fill Form?", "generateDocumentBranchManager")}
            >
              {isDeveloper ? "Edit" : "Generate Document"}
            </Button>
          </div>
        )}
      {isDeveloper && (
        <div className="mb-1">
          <Button
            variant="danger"
            onClick={() => handleDelMember(item.id)}
          >
            <RxCross2 size={20} /> Delete Case
          </Button>
        </div>
      )}
      {(roleId === "Branch Manager" || isDeveloper) &&
        loanType === "GP Loan" &&
        item.fieldManagerStatus === "submitted" &&
        (item.misStatus !== "pending" && item.misStatus !== null && item.misStatus !== "" && item.misStatus !== "retrigger") &&
        item.creditManagerStatus === "submitted" && (
          <div className="mb-1">
            <Button
              onClick={() => handleSubmit(item.id, "Are you sure you want to Upload?", "uploadBranchManagerDocument")}
            >
              Upload Document
            </Button>
          </div>
        )}
      {(((roleId === "Branch Manager" || isDeveloper) &&
        loanType === "Business Loan" &&
        item.fieldManagerStatus === "submitted" &&
        item.branchManagerStatus === "submitted" &&
        item.creditOfficerStatus === "submitted" &&
        item.misStatus === "submitted" &&
        item.creditManagerStatus === "submitted" &&
        item.sanctionCommitteeStatus === "approved" &&
        item.accountManagerStatus === "pending") ||
        ((roleId === "Branch Manager" || isDeveloper) &&
          loanType === "Business Loan" &&
          item.fieldManagerStatus === "submitted" &&
          ["retrigger"].includes(item.branchManagerStatus) &&
          item.creditOfficerStatus === "submitted" &&
          item.misStatus === "submitted" &&
          item.creditManagerStatus === "submitted" &&
          item.sanctionCommitteeStatus === "approved")) && (
          <div className="mb-1">
            <Button
              onClick={() => handleSubmit(item.id, "Are you sure you want to Upload?", "uploadBranchManagerDocument")}
            >
              Upload Document
            </Button>
          </div>
        )}
      {(roleId === "Branch Manager" || isDeveloper) &&
        loanType === "GP Loan" &&
        item.fieldManagerStatus === "submitted" &&
        (item.misStatus !== "pending" && item.misStatus !== null && item.misStatus !== "" && item.misStatus !== "retrigger") &&
        item.creditManagerStatus === "submitted" &&
        item.accountManagerStatus === "pending" && (
          <div className="mb-1">
            <Button
              onClick={() => handleSubmit(item.id, "Are you sure you want to Disburse?", "disburseBranchManager")}
            >
              Disburse
            </Button>
          </div>
        )}
      {(((roleId === "Branch Manager" || isDeveloper) &&
        loanType === "Business Loan" &&
        item.fieldManagerStatus === "submitted" &&
        item.branchManagerStatus === "submitted" &&
        item.creditOfficerStatus === "submitted" &&
        item.misStatus === "submitted" &&
        item.creditManagerStatus === "submitted" &&
        item.sanctionCommitteeStatus === "approved" &&
        ["pending"].includes(item.accountManagerStatus)) ||
        ((roleId === "Branch Manager" || isDeveloper) &&
          loanType === "Business Loan" &&
          item.fieldManagerStatus === "submitted" &&
          ["retrigger"].includes(item.branchManagerStatus) &&
          item.creditOfficerStatus === "submitted" &&
          item.misStatus === "submitted" &&
          item.creditManagerStatus === "submitted" &&
          item.sanctionCommitteeStatus === "approved")) && (
          <div className="mb-1">
            <Button
              onClick={() => handleSubmit(item.id, "Are you sure you want to Disburse?", "disburseBranchManager")}
            >
              Disburse
            </Button>
          </div>
        )}
      {(roleId === "MIS" || isDeveloper) &&
        loanType === "Business Loan" &&
        item.fieldManagerStatus === "submitted" &&
        item.branchManagerStatus === "disbursed" &&
        item.creditOfficerStatus === "submitted" &&
        item.misStatus === "submitted" &&
        item.creditManagerStatus === "submitted" &&
        item.sanctionCommitteeStatus === "approved" &&
        item.accountManagerStatus === "pending" && (
          <div className="mb-1">
            <Button
              onClick={() => handleSubmit(item.id, "Are you sure you want to Disburse?", "disburseMis")}
            >
              Disburse
            </Button>
          </div>
        )}
      {/* Daily Loan reaches the Sanction Committee straight from the Credit
          Officer: there is no MIS or Credit Manager stage, and the Branch
          Manager disburses AFTER this approval rather than before it. So this
          condition deliberately checks neither misStatus, creditManagerStatus
          nor branchManagerStatus - requiring any of them would hide the button
          for every DL loan, which is what the Business Loan block below does. */}
      {(roleId === "Sanction Committee" || isDeveloper) &&
        loanType === "Daily Loan" &&
        item.fieldManagerStatus === "submitted" &&
        item.creditOfficerStatus === "submitted" &&
        ["pending", "retrigger"].includes(item.sanctionCommitteeStatus) && (
          <div className="mb-2">
            <Button
              variant="success"
              onClick={() => handleSubmit(item.id, "Are you sure you want to Approve?", "approveSanctionCommittee")}
            >
              <TiTick size={20} />
            </Button>
          </div>
        )}

      {/* ── Daily Loan: Step 1 – Save Terms ──────────────────────────────
          Shown after SC approves, before collection time & date have been saved. */}
      {/* Daily Loan disbursement is mobile-only for the Branch Manager (per
          the DL business rules) - excluded here from web so only `isDeveloper`
          can still reach it for testing. Mobile's own ActionButtons.js is
          untouched. */}
      {isDeveloper &&
        loanType === "Daily Loan" &&
        item.sanctionCommitteeStatus === "approved" &&
        (!item.collectionTime || !item.installmentStartDate) &&
        item.branchManagerStatus !== "disbursed" &&
        !isRejected && (
          <div className="mb-1">
            <Button
              variant="info"
              onClick={() => {
                setMemberId(item.id);
                setShowDlTermsModal(true);
              }}
            >
              Save Loan Terms
            </Button>
          </div>
        )}

      {/* ── Daily Loan: Edit Terms ────────────────────────────────────────
          Available once terms are saved, until loan is disbursed. */}
      {/* Daily Loan disbursement is mobile-only for the Branch Manager (per
          the DL business rules) - excluded here from web so only `isDeveloper`
          can still reach it for testing. Mobile's own ActionButtons.js is
          untouched. */}
      {isDeveloper &&
        loanType === "Daily Loan" &&
        item.sanctionCommitteeStatus === "approved" &&
        item.collectionTime &&
        item.installmentStartDate &&
        item.branchManagerStatus !== "disbursed" &&
        !isRejected && (
          <div className="mb-1">
            <Button
              variant="outline-info"
              onClick={() => {
                setMemberId(item.id);
                setShowDlTermsModal(true);
              }}
            >
              Edit Terms
            </Button>
          </div>
        )}

      {/* ── Daily Loan: Step 2 – Signature ────────────────────────────────
          Terms saved. Customer signature not yet captured. */}
      {/* Daily Loan disbursement is mobile-only for the Branch Manager (per
          the DL business rules) - excluded here from web so only `isDeveloper`
          can still reach it for testing. Mobile's own ActionButtons.js is
          untouched. */}
      {isDeveloper &&
        loanType === "Daily Loan" &&
        item.sanctionCommitteeStatus === "approved" &&
        item.collectionTime &&
        item.installmentStartDate &&
        !item.customerSignatureFile &&
        item.branchManagerStatus !== "disbursed" &&
        !isRejected && (
          <div className="mb-1">
            <Button
              variant="info"
              onClick={() => {
                setMemberId(item.id);
                setShowDlSignatureModal(true);
              }}
            >
              Capture Signature
            </Button>
          </div>
        )}

      {/* ── Daily Loan: Step 3 – Generate Document ────────────────────────
          Signature saved, agreement not yet generated. */}
      {/* Daily Loan disbursement is mobile-only for the Branch Manager (per
          the DL business rules) - excluded here from web so only `isDeveloper`
          can still reach it for testing. Mobile's own ActionButtons.js is
          untouched. */}
      {isDeveloper &&
        loanType === "Daily Loan" &&
        item.sanctionCommitteeStatus === "approved" &&
        item.customerSignatureFile &&
        !item.loanAgreementFile &&
        item.branchManagerStatus !== "disbursed" &&
        !isRejected && (
          <div className="mb-1">
            <Button
              variant="primary"
              onClick={async () => {
                try {
                  const res = await axios.post(
                    `${BASE_URL}/api/generateDlAgreement`,
                    { memberId: item.id }
                  );
                  const filename = res.data?.loanAgreementFile;
                  if (filename) {
                    window.open(`${BASE_URL}/images/${filename}`, "_blank");
                  }
                  updateList();
                } catch (err) {
                  const msg =
                    err.response?.data?.error ||
                    err.response?.data?.details ||
                    "Failed to generate agreement.";
                  alert(msg);
                }
              }}
            >
              Generate Agreement
            </Button>
          </div>
        )}

      {/* ── Daily Loan: Step 4 – Attach Proof Image ──────────────────────
          Agreement generated, the single mandatory proof image still missing.
          This used to also require a second "cashHandover" photo; the client
          asked for one proof field instead. */}
      {/* Daily Loan disbursement is mobile-only for the Branch Manager (per
          the DL business rules) - excluded here from web so only `isDeveloper`
          can still reach it for testing. Mobile's own ActionButtons.js is
          untouched. */}
      {isDeveloper &&
        loanType === "Daily Loan" &&
        item.sanctionCommitteeStatus === "approved" &&
        item.loanAgreementFile &&
        !item.dlSignedDocumentPhoto &&
        item.branchManagerStatus !== "disbursed" &&
        !isRejected && (
          <div className="mb-1">
            <Button
              variant="warning"
              onClick={() => {
                setMemberId(item.id);
                setShowDlProofPhotosModal(true);
              }}
            >
              Attach Proof Image
            </Button>
          </div>
        )}

      {/* ── Daily Loan: Step 5 – Disburse ────────────────────────────────
          All prerequisites met: terms, signature, agreement, proof image.
          Mirrors confirmDlDisbursement.js's server-side check exactly - keep
          the two in step, or the button shows for a loan the server refuses. */}
      {/* Daily Loan disbursement is mobile-only for the Branch Manager (per
          the DL business rules) - excluded here from web so only `isDeveloper`
          can still reach it for testing. Mobile's own ActionButtons.js is
          untouched. */}
      {isDeveloper &&
        loanType === "Daily Loan" &&
        item.sanctionCommitteeStatus === "approved" &&
        item.customerSignatureFile &&
        item.loanAgreementFile &&
        item.dlSignedDocumentPhoto &&
        item.branchManagerStatus !== "disbursed" &&
        !isRejected && (
          <div className="mb-1">
            <Button
              variant="success"
              onClick={async () => {
                if (!window.confirm("Are you sure you want to disburse this Daily Loan?")) return;
                try {
                  await axios.post(`${BASE_URL}/api/confirmDlDisbursement`, {
                    memberId: item.id,
                  });
                  updateList();
                } catch (err) {
                  const msg =
                    err.response?.data?.error ||
                    err.response?.data?.details ||
                    "Failed to disburse. Please try again.";
                  alert(msg);
                }
              }}
            >
              Disburse
            </Button>
          </div>
        )}

      {(roleId === "Sanction Committee" || isDeveloper) &&
        loanType === "Business Loan" &&
        item.fieldManagerStatus === "submitted" &&
        item.branchManagerStatus === "submitted" &&
        item.creditOfficerStatus === "submitted" &&
        item.misStatus === "submitted" &&
        item.creditManagerStatus === "submitted" &&
        ["pending", "retrigger"].includes(item.sanctionCommitteeStatus) && (
          <div className="mb-2">
            <Button
              variant="success"
              onClick={() => handleSubmit(item.id, "Are you sure you want to Approve?", "approveSanctionCommittee")}
            >
              <TiTick size={20} />
            </Button>
          </div>
        )}
      {(roleId === "Accounts Manager" || isDeveloper) &&
        item.fieldManagerStatus === "submitted" &&
        item.branchManagerStatus === "disbursed" &&
        (item.loanType === "GP Loan" || item.creditOfficerStatus === "submitted") &&
        ((item.loanType === "Business Loan" && item.misStatus === "disbursed") ||
          (item.loanType === "GP Loan" && item.misStatus === "recheckFinally") ||
          // Daily Loan has no MIS stage at all, so both clauses above are false
          // for it and this whole condition collapsed - the Submit button never
          // rendered. DL is ready for payment once the Branch Manager has
          // disbursed, which is already required above.
          item.loanType === "Daily Loan") &&
        (item.loanType === "GP Loan" || item.sanctionCommitteeStatus === "approved") &&
        item.accountManagerStatus === "pending" && (
          <div className="mb-1">
            <Button
              onClick={() => handleSubmit(item.id, "Are you sure you want to Submit?", "submitAccountManager")}
            >
              Submit
            </Button>
          </div>
        )}
      {loanType?.toString().toLowerCase().trim() === "gp loan" &&
        (roleId === "Branch Manager" || isDeveloper) &&
        item.fieldManagerStatus === "submitted" &&
        !isRejected &&
        ["pending", "retrigger"].includes(item.branchManagerStatus) && 
        item.creditManagerStatus !== "submitted" && (
          <div className="mb-1">
            <Button onClick={() => handleSubmit(item.id, "", "showBookingBm")}>
              Show Booking Process
            </Button>
          </div>
        )}
      {loanType?.toString().toLowerCase().trim() === "gp loan" &&
        (roleId === "Branch Manager" || isDeveloper) &&
        item.fieldManagerStatus === "submitted" &&
        !isRejected &&
        ["pending", "retrigger"].includes(item.branchManagerStatus) && 
        item.creditManagerStatus !== "submitted" &&(
          <div className="mb-1">
            <Button onClick={() => handleSubmit(item.id, "", "uploadAndSubmitBmBooking")}>
              Upload Booking Process Documents
            </Button>
          </div>
        )}
      {loanType === "GP Loan" &&
        (roleId === "MIS" || isDeveloper) &&
        item.fieldManagerStatus === "submitted" &&
        item.branchManagerStatus === "submitted" &&
        ["pending", "retrigger"].includes(item.misStatus) && (
          <div className="mb-1">
            <Button
              variant="success"
              onClick={() => handleSubmit(item.id, "Are you sure you want to Submit?", "orderPlacedMis")}
            >
              <TiTick size={20} /> Place Order
            </Button>
          </div>
        )}
      {loanType === "GP Loan" &&
        (roleId === "MIS" || isDeveloper) &&
        item.fieldManagerStatus === "submitted" &&
        item.branchManagerStatus === "disbursed" &&
        ["orderPlaced", "retrigger", "retrigger_stage2"].includes(item.misStatus) && (
          <div className="mb-1">
            <Button
              variant="success"
              onClick={() => handleSubmit(item.id, "Are you sure you want to Submit?", "recheckFinally")}
            >
              <TiTick size={20} /> Final Recheck
            </Button>
          </div>
        )}
      {showApproveModal && (
        <ApproveModal
          show={showApproveModal}
          handleClose={handleCloseApprove}
          handleConfirm={handleApproveConfirm}
          message={message}
        />
      )}
      {showRetriggerModal && (
        <RetriggerModal
          show={showRetriggerModal}
          handleClose={handleCloseRetrigger}
          handleConfirm={handleRetriggerConfirm}
          message={message}
          comment={comment}
          setComment={setComment}
          retriggerToRole={retriggerToRole}
          setRetriggerToRole={setRetriggerToRole}
          availableRoles={availableRetriggerRoles()}
          roleId={roleId}
          item={item}
          loanType={loanType}
        />
      )}
      {showRejectModal && (
        <RejectModal
          show={showRejectModal}
          handleClose={handleCloseReject}
          handleConfirm={handleRejectConfirm}
          message={message}
          comment={comment}
          setComment={setComment}
        />
      )}
      {showApproveCreditManagerModal && (
        <ApproveCreditManagerModal
          show={showApproveCreditManagerModal}
          handleClose={handleCloseApproveCreditManager}
          handleConfirm={handleApproveConfirmCreditManager}
          message={message}
          memberId={memberId}
          creditManagerId={managerId}
          proposedLoanAmount={proposedLoanAmount}
        />
      )}
      {showDisburseMisModal && (
        <DisburseMisModal
          show={showDisburseMisModal}
          handleClose={handleCloseDisburseMis}
          handleConfirm={handleDisburseConfirmMis}
          message={message}
          comment={comment}
          setComment={setComment}
        />
      )}
      {showApproveMisModal && (
        <ApproveMisModal
          show={showApproveMisModal}
          handleClose={handleCloseApproveMis}
          handleConfirm={handleApproveConfirmMis}
          message={message}
          comment={comment}
          setComment={setComment}
        />
      )}
      {showApproveSanctionCommitteeModal && (
        <ApproveSanctionCommitteeModal
          show={showApproveSanctionCommitteeModal}
          handleClose={handleCloseApproveSanctionCommittee}
          handleConfirm={handleApproveConfirmSanctionCommittee}
          message={message}
          loanAmount={sanctionedLoanAmount}
          setLoanAmount={setSanctionedLoanAmount}
          proposedLoanAmount={proposedLoanAmount}
        />
      )}
      {showApproveAccountManagerModal && (
        <ApproveAccountManagerModal
          show={showApproveAccountManagerModal}
          handleClose={handleCloseApproveAccountManager}
          handleConfirm={handleApproveConfirmAccountManager}
          message={message}
          transactionAccountNumber={transactionAccountNumber}
          setTransactionAccountNumber={setTransactionAccountNumber}
          transactionRefNo={transactionRefNo}
          setTransactionRefNo={setTransactionRefNo}
          transactionDate={transactionDate}
          setTransactionDate={setTransactionDate}
          transactionAmount={transactionAmount}
          setTransactionAmount={setTransactionAmount}
          proposedLoanAmount={proposedLoanAmount}
          sanctionedLoanAmount={sanctionedLoanAmount}
          processingCharge={loanType === "GP Loan" ? (loanFormDetails?.processingCharge || 0) : processingCharge}
          // processingCharge={processingCharge}
          isProcessingChargePaid={isProcessingChargePaid}
          // gst={gst}
          gst={loanType === "GP Loan" ? (loanFormDetails?.gst || 0) : gst}
          isGstPaid={isGstPaid}
          securityDeposit={securityDeposit}
          isSecurityDepositPaid={isSecurityDepositPaid}
          isLoanInsured={isLoanInsured}
          // insuranceAmount={insuranceAmount}
          insuranceAmount={loanType === "GP Loan" ? (loanFormDetails?.insuranceAmount || 0) : insuranceAmount}
          isInsuranceAmountPaid={isInsuranceAmountPaid}
          amountToRelease={amountToRelease}
          loanType={loanType}
          ornamentModelNoByBm={ornamentModelNoByBm}
          setOrnamentModelNoByBm={setOrnamentModelNoByBm}
          ornamentNameByBm={ornamentNameByBm}
          setOrnamentNameByBm={setOrnamentNameByBm}
          ornamentWeightByBm={ornamentWeightByBm}
          setOrnamentWeightByBm={setOrnamentWeightByBm}
          wastageByBm={wastageByBm}
          setWastageByBm={setWastageByBm}
          gstByBm={gstByBm}
          setGstByBm={setGstByBm}
          goldRateByBm={goldRateByBm}
          setGoldRateByBm={setGoldRateByBm}
          ornamentWeightValueByBm={ornamentWeightValueByBm}
          wastageValueByBm={wastageValueByBm}
          totalByBm={totalByBm}
          gstValueByBm={gstValueByBm}
          eligibleLoanAmountByBm={eligibleLoanAmountByBm}
          totalLoanAmountByBm={totalLoanAmountByBm}
          fundingAgencyData={fundingAgencyData}
        />
      )}
      {showUploadBranchManagerDocumentModal && (
        <UploadBranchManagerDocument
          show={showUploadBranchManagerDocumentModal}
          handleClose={handleCloseUploadBranchManagerDocument}
          handleConfirm={handleApproveConfirmUploadBranchManagerDocument}
          message={message}
          memberId={memberId}
          branchManagerId={managerId}
        />
      )}

      {showDisburseBranchManagerModal && (
        <DisburseBranchManagerModal
          show={showDisburseBranchManagerModal}
          handleClose={handleCloseDisburseBranchManager}
          handleConfirm={handleDisburseConfirmBranchManager}
          message={message}
          processingCharge={loanType === "GP Loan" ? (loanFormDetails?.processingCharge || 0) : processingCharge}
          isProcessingChargePaid={isProcessingChargePaid}
          setIsProcessingChargePaid={setIsProcessingChargePaid}
          gst={loanType === "GP Loan" ? (loanFormDetails?.gst || 0) : gst}
          isGstPaid={isGstPaid}
          setIsGstPaid={setIsGstPaid}
          securityDeposit={securityDeposit}
          isSecurityDepositPaid={isSecurityDepositPaid}
          setIsSecurityDepositPaid={setIsSecurityDepositPaid}
          securityDeposit1={securityDeposit1}
          isSecurityDeposit1Paid={isSecurityDeposit1Paid}
          setIsSecurityDeposit1Paid={setIsSecurityDeposit1Paid}
          isLoanInsured={isLoanInsured}
          setIsLoanInsured={setIsLoanInsured}
          insuranceAmount={loanType === "GP Loan" ? (loanFormDetails?.insuranceAmount || 0) : insuranceAmount}
          isInsuranceAmountPaid={isInsuranceAmountPaid}
          setIsInsuranceAmountPaid={setIsInsuranceAmountPaid}
          amountToRelease={amountToRelease}
          setAmountToRelease={setAmountToRelease}
          emiDateByBranchManager={emiDateByBranchManager}
          setEmiDateByBranchManager={setEmiDateByBranchManager}
          loanType={loanType}
          proposedLoanAmount={proposedLoanAmount}
          sanctionedLoanAmount={sanctionedLoanAmount}
          ornamentModelNoByBm={ornamentModelNoByBm}
          setOrnamentModelNoByBm={setOrnamentModelNoByBm}
          ornamentNameByBm={ornamentNameByBm}
          setOrnamentNameByBm={setOrnamentNameByBm}
          ornamentWeightByBm={ornamentWeightByBm}
          setOrnamentWeightByBm={setOrnamentWeightByBm}
          wastageByBm={wastageByBm}
          setWastageByBm={setWastageByBm}
          gstByBm={gstByBm}
          setGstByBm={setGstByBm}
          goldRateByBm={goldRateByBm}
          setGoldRateByBm={setGoldRateByBm}
          ornamentWeightValueByBm={ornamentWeightValueByBm}
          wastageValueByBm={wastageValueByBm}
          totalByBm={totalByBm}
          gstValueByBm={gstValueByBm}
          eligibleLoanAmountByBm={eligibleLoanAmountByBm}
          totalLoanAmountByBm={totalLoanAmountByBm}
          goldloantotal={goldLoanTotal}
          cashtloanotal={cashLoanTotal}
        />
      )}
      {showGenerateDocumentBranchManagerModal && (
        <GenerateDocumentBranchManagerModal
          show={showGenerateDocumentBranchManagerModal}
          handleClose={handleCloseGenerateDocumentBranchManager}
          handleConfirm={handleGenerateDocumentConfirmBranchManager}
          message={message}
          tenureInMonths={tenureInMonths}
          proposedLoanAmount={proposedLoanAmount}
          setProposedLoanAmount={setProposedLoanAmount}
          sanctionedLoanAmount={sanctionedLoanAmount}
          setSanctionedLoanAmount={setSanctionedLoanAmount}
          processingCharge={processingCharge}
          setProcessingCharge={setProcessingCharge}
          isProcessingChargePaid={isProcessingChargePaid}
          setIsProcessingChargePaid={setIsProcessingChargePaid}
          gst={gst}
          setGst={setGst}
          isGstPaid={isGstPaid}
          setIsGstPaid={setIsGstPaid}
          securityDeposit={securityDeposit}
          setSecurityDeposit={setSecurityDeposit}
          isSecurityDepositPaid={isSecurityDepositPaid}
          setIsSecurityDepositPaid={setIsSecurityDepositPaid}
          securityDeposit1={securityDeposit1}
          setSecurityDeposit1={setSecurityDeposit1}
          isSecurityDeposit1Paid={isSecurityDeposit1Paid}
          setIsSecurityDeposit1Paid={setIsSecurityDeposit1Paid}
          isLoanInsured={isLoanInsured}
          setIsLoanInsured={setIsLoanInsured}
          insuranceAmount={insuranceAmount}
          setInsuranceAmount={setInsuranceAmount}
          isInsuranceAmountPaid={isInsuranceAmountPaid}
          setIsInsuranceAmountPaid={setIsInsuranceAmountPaid}
          amountToRelease={amountToRelease}
          setAmountToRelease={setAmountToRelease}
          emiDateByBranchManager={emiDateByBranchManager}
          setEmiDateByBranchManager={setEmiDateByBranchManager}
          installmentStartDate={installmentStartDate}
          setInstallmentStartDate={setInstallmentStartDate}
          disbursementDate={item?.branchManagerStatusUpdatedAt}
          fundingAgencyData={fundingAgencyData}
          loanType={loanType}
          ornamentModelNoByBm={ornamentModelNoByBm}
          setOrnamentModelNoByBm={setOrnamentModelNoByBm}
          ornamentNameByBm={ornamentNameByBm}
          setOrnamentNameByBm={setOrnamentNameByBm}
          ornamentWeightByBm={ornamentWeightByBm}
          setOrnamentWeightByBm={setOrnamentWeightByBm}
          wastageByBm={wastageByBm}
          setWastageByBm={setWastageByBm}
          gstByBm={gstByBm}
          setGstByBm={setGstByBm}
          goldRateByBm={goldRateByBm}
          setGoldRateByBm={setGoldRateByBm}
          ornamentWeightValueByBm={ornamentWeightValueByBm}
          wastageValueByBm={wastageValueByBm}
          totalByBm={totalByBm}
          gstValueByBm={gstValueByBm}
          eligibleLoanAmountByBm={eligibleLoanAmountByBm}
          totalLoanAmountByBm={totalLoanAmountByBm}
          setTotalLoanAmountByBm={setTotalLoanAmountByBm}
          needCashLoan={needCashLoan}
          setNeedCashLoan={setNeedCashLoan}
          cashLoanAmount={cashLoanAmount}
          setCashLoanAmount={setCashLoanAmount}
        />
      )}
      {showBookingProcessModal && (
        <ShowBookingProcessModal
          show={showBookingProcessModal}
          handleClose={handleCloseBookingProcess}
          handleConfirm={handleSaveBookingProcess}
          bookingProcessData={bookingProcessData}
          memberId={memberId}
        />
      )}
      {showUploadBranchManagerBookingDocumentsStaticModal && (
        <UploadBranchManagerBookingDocumentsStatic
          show={showUploadBranchManagerBookingDocumentsStaticModal}
          handleClose={handleCloseUploadBookingProcess}
          handleConfirm={handleSubmitUploadBookingProcess}
          memberId={memberId}
        />
      )}

      {/* ── Daily Loan BM modals ── */}
      {showDlTermsModal && (
        <SaveDlTermsModal
          show={showDlTermsModal}
          handleClose={() => setShowDlTermsModal(false)}
          memberId={memberId}
          initialCollectionTime={item?.collectionTime}
          initialStartDate={item?.installmentStartDate}
          initialTenure={item?.proposedLoanDetails?.tenureInMonths}
          onSuccess={() => updateList()}
        />
      )}
      {showDlSignatureModal && (
        <DlSignatureModal
          show={showDlSignatureModal}
          handleClose={() => setShowDlSignatureModal(false)}
          memberId={memberId}
          onSuccess={() => updateList()}
        />
      )}
      {showDlProofPhotosModal && (
        <DlProofPhotosModal
          show={showDlProofPhotosModal}
          handleClose={() => setShowDlProofPhotosModal(false)}
          memberId={memberId}
          dlSignedDocumentPhoto={item?.dlSignedDocumentPhoto}
          onSuccess={() => updateList()}
        />
      )}
    </div>
  );
};

export default ActionButtons;